<template>
  <div>
    <v-row>
      <v-col md="6" lg="5" sm="12">
        <s-crud
          noSearch
          noFooter
          :config="this.config"
          @save="saveDef($event)"
          :add="!isSpecialOnly"
          :edit="!isSpecialOnly"
          :remove="!isSpecialOnly"
          title="Platos"
          @rowSelected="selectMlt($event)"
        >
          <template scope="props">
            <v-container>
              <v-row>
                <v-col
                  ><s-select-definition
                    :def="1065"
                    label="Selecciona Tipo"
                    v-model="props.item.TypeMeal"
                  ></s-select-definition
                ></v-col>
              </v-row>
              <v-row>
                <v-col xs="12">
                  <s-text
                    v-model="props.item.MltPriceDefault" decimal
                    label="Precio"
                  ></s-text
                ></v-col>
                <v-col xs="12">
                  <s-text
                    v-model="props.item.MltDiscountDefault"
                    label="Descuento" decimal
                  ></s-text
                ></v-col>
              </v-row>
              <v-row>
                <v-col sm="4"
                  ><s-time
                    v-model="props.item.MltBeginHour"
                    label="Hora de Inicio"
                  ></s-time>
                </v-col>
                <v-col sm="4"
                  ><s-time
                    v-model="props.item.MltEndHour"
                    label="Hora de Fin"
                  ></s-time>
                </v-col>
                   <v-col xs="4">
                  <s-text max="1" number
                    v-model="props.item.MltBeforeHoursCancel"
                    label="Horas Cancelación"
                  ></s-text
                ></v-col>
              </v-row>
            </v-container>
          </template>
        </s-crud>
      </v-col>
      <v-col md="6" lg="4" sm="12">
        <s-crud
          noSearch
          title="Tarifas"
          :filter="filter"
          v-if="filter != null"
          :config="this.configRate"
          @save="saveRate($event)"
          add
          edit
          remove
          noFooter
        >
          <template scope="props">
            <v-col>
              <!-- ALERTA IMPACTANTE: Tarifa Aprobada Bloqueada -->
              <div
                v-if="props.item.MlrApprovalStatus === 2"
                class="modern-alert alert-locked mb-3 pa-3 rounded elevation-1"
              >
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <div class="alert-icon-box icon-locked mr-3">
                      <v-icon color="white">mdi-lock</v-icon>
                    </div>
                    <div>
                      <div class="alert-title alert-title-locked">
                        TARIFA APROBADA (SOLO LECTURA)
                      </div>
                      <div class="alert-desc alert-desc-locked">
                        Esta tarifa especial ya está aprobada y no puede modificarse. Para cambiar precios o alcance debe registrar una nueva tarifa.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ALERTA IMPACTANTE: Tarifa Especial Pendiente -->
              <div
                v-else-if="isSpecialMenu(props.item.MntID)"
                class="modern-alert alert-pending mb-3 pa-3 rounded elevation-1"
              >
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <div class="alert-icon-box icon-pending mr-3">
                      <v-icon color="white">mdi-shield-alert</v-icon>
                    </div>
                    <div>
                      <div class="alert-title alert-title-pending">
                        SUJETO A APROBACIÓN PREVIA
                      </div>
                      <div class="alert-desc alert-desc-pending">
                        Toda tarifa especial se registra en estado <strong>Pendiente</strong> y requerirá aprobación desde la bandeja para entrar en vigencia.
                      </div>
                    </div>
                  </div>
                  <v-chip small color="primary" text-color="white" class="font-weight-bold ml-2 elevation-1">
                    PENDIENTE
                  </v-chip>
                </div>
              </div>

              <v-row>
                <v-col
                  ><s-select-generic
                    itemtext="MntName"
                    itemvalue="MntID"
                    id="MntID"
                    v-model="props.item.MntID"
                    :config="configMenuSelect"
                  ></s-select-generic
                ></v-col>
              </v-row>

              <!-- SELECTOR DE ALCANCE: DEFINICIÓN 1760 DE BASE DE DATOS -->
              <v-row v-if="isSpecialMenu(props.item.MntID)">
                <v-col cols="12">
                  <s-select-definition
                    :def="1760"
                    v-model="props.item.MlrScope"
                    label="Alcance del Menú Especial"
                  ></s-select-definition>
                </v-col>
              </v-row>
              <v-row v-if="isSpecialMenu(props.item.MntID)">
                <v-col>
                  <s-text
                    v-model="props.item.MlrDescription"
                    label="Motivo / Evento (ej. Día de la Madre, Aniversario)"
                  ></s-text>
                </v-col>
              </v-row>
              <v-row
                ><v-col
                  ><s-text
                    decimal
                    label="Precio"
                    v-model="props.item.MlrPrice"
                  ></s-text
                ></v-col>
                <v-col
                  ><s-text
                    label="Descuento" decimal
                    v-model="props.item.MrlDiscount"
                  ></s-text></v-col
              ></v-row>
              <v-row>
                <v-col
                  ><s-date
                    v-model="props.item.MlrValidityDate"
                    label="Fecha Inicio"
                  ></s-date> </v-col
                >
                <v-col v-if="isSpecialMenu(props.item.MntID)">
                  <s-date
                    v-model="props.item.MlrValidityEndDate"
                    label="Fecha Fin"
                  ></s-date>
                </v-col>
              </v-row>
            </v-col>
          </template>
          <template v-slot:ApprovalStatusText="{ row }">
            <v-chip
              v-if="row.ApprovalStatusText"
              x-small
              :color="row.MlrApprovalStatus === 2 ? 'green darken-1' : (row.MlrApprovalStatus === 3 ? 'red darken-1' : 'orange darken-2')"
              text-color="white"
              class="font-weight-bold"
            >
              {{ row.ApprovalStatusText }}
            </v-chip>
            <span v-else class="grey--text text--lighten-1 caption">-</span>
          </template>
        </s-crud>
      </v-col>
      <v-col md="6" lg="3" sm="12">
        <s-crud
          noSearch
          title="Contenido"
          v-if="filter != null"
          :config="this.configDetail"
          @save="saveDetail($event)"
          noFooter
          :filter="filter"
          :add="!isSpecialOnly"
          :remove="!isSpecialOnly"
          
        >
          <template scope="props">
            <v-col>
              <s-select-definition
                :def="1079"
                v-model="props.item.TypeContent"
                label="Tipo de Contenido"
              ></s-select-definition>
            </v-col>
          </template>
        </s-crud>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Service from "./../../services/DinningHall/MealTypeService";
import TypeDetailService from "./../../services/DinningHall/MealTypeDetailService.";
import RateService from "./../../services/DinningHall/MealRateService";
import MenuService from "./../../services/DinningHall/MenuTypeService";
export default {
  name: "MealType",
  components: {},

  data: () => ({
    menuList: [],
    disabledRate: false,
    configMenuSelect: {
      url: MenuService.getUrllist(),
      params: {},
      title: "Tipo de Menú",
    },
    parentID: null,
    filter: null,
    config: {
      model: {
        TypeMeal: "int",
        MltID: "ID",
        MltBeginHour: "time",
        MltEndHour: "time",
        MltPriceDefault: "int",
        MltDiscountDefault: "int",
        SecStatus: "booleam",
        MltBeforeHoursCancel:"int",
      },
      title: "PLATOS COMEDOR",
      service: Service,
      headers: [
        { text: "Plato", value: "TypeMealText", sortable: false },
        { text: "Inicio", value: "MltBeginHour", sortable: false },
        { text: "Fin", value: "MltEndHour", sortable: false },
        { text: "Precio", value: "MltPriceDefault", sortable: false },
        { text: "Desc", value: "MltDiscountDefault", sortable: false },
      ],
    },
    configRate: {
      model: {
        MlrID: "ID",
        MltID: "ID",
        MntID: "ID",
        MlrValidityDate: "date",
        MlrValidityEndDate: "date",
        MlrPrice: "int",
        MrlDiscount: "int",
        SecStatus: "booleam",
        MlrDescription: "string",
        MlrApprovalStatus: "int",
        ApprovalStatusText: "string",
        MlrScope: "int",
        ScopeText: "string",
      },
      title: "TARIFAS COMEDOR",
      service: RateService,
      headers: [
        { text: "Tipo", value: "TypeMenuText", sortable: false },
        { text: "Precio", value: "MlrPrice", sortable: false },
        { text: "Desc", value: "MrlDiscount", sortable: false },
        { text: "Inicio", value: "MlrValidityDate", sortable: false },
        { text: "Fin", value: "MlrValidityEndDate", sortable: false },
        { text: "Estado", value: "ApprovalStatusText", sortable: false },
        { text: "Alcance", value: "ScopeText", sortable: false },
      ],
    },
    configDetail: {
      model: {
        TypeContent: "int",
        MtdID: "ID",
        MltID: "int",
        SecStatus: "booleam",
      },
      title: "PLATOS COMEDOR",
      service: TypeDetailService,
      headers: [
        { text: "ID", value: "MtdID", sortable: false },
        {
          text: "Tipo de Contenido",
          value: "TypeContentText",
          sortable: false,
        },
      ],
    },
  }),
  computed: {
    isSpecialOnly() {
      return this.$fun.hasSpecialPermission("SpecialMealOnly");
    },
  },
  mounted() {
    this.configMenuSelect.url = MenuService.getUrllist();
    this.loadMenus();
  },

  methods: {
    async loadMenus() {
      try {
        const res = await this.$http.post("dinningHall/menutype/list");
        this.menuList = res.data || [];
      } catch (e) {
        console.error("Error al cargar menús:", e);
      }
    },
    isSpecialMenu(mntID) {
      if (!mntID) return false;
      const found = this.menuList.find((m) => m.MntID === mntID);
      if (found) {
        const name = (found.MntName || "").toUpperCase();
        return name.includes("ESPECIAL") || found.MntAbbreviature === "ESP";
      }
      return mntID === 49;
    },
    selectMlt(items) {
      if (items.length > 0) {
        this.parentID = items[0].MltID;
        this.filter = { MltID: this.parentID };
      }
    },
    saveDef(item) {
      if (this.isSpecialOnly) {
        this.$fun.alert("Su usuario solo cuenta con permisos para gestionar tarifas de Menú Especial.", "warning");
        return;
      }
      if (item.TypeMeal == 0) {
        this.$fun.alert("Elija Tipo de Plato", "warning");
        return;
      }
      //  if(!this.$fun.IsValidDecimal(item.MltPriceDefault) ){ this.$fun.alert('Precio Incorrecto','warning');return;};
      // if(!this.$fun.IsValidDecimal(item.MltDiscountDefault)){ this.$fun.alert('Descuento Incorrecto','warning');return;};
      item.save();
    },
    saveRate(item) {
      if (item.MlrID && item.MlrApprovalStatus === 2) {
        this.$fun.alert(
          "Esta tarifa especial ya se encuentra APROBADA y no puede ser modificada. Para cambiar condiciones o precios debe crear una nueva tarifa.",
          "warning"
        );
        return;
      }
      if (this.isSpecialOnly && !this.isSpecialMenu(item.MntID)) {
        this.$fun.alert("Su usuario solo cuenta con permisos para gestionar tarifas de Menú Especial.", "warning");
        return;
      }
      if (!item.MntID || item.MntID == 0) {
        this.$fun.alert("Elija Tipo de Menú", "warning");
        return;
      }
      if (this.isSpecialMenu(item.MntID)) {
        if (!item.MlrScope) {
          item.MlrScope = 1;
        }
        if (!item.MlrDescription || !item.MlrDescription.trim()) {
          this.$fun.alert("Ingrese el motivo u ocasión de la tarifa especial (ej. Día de la Madre, Aniversario)", "warning");
          return;
        }
        if (!item.MlrValidityEndDate) {
          item.MlrValidityEndDate = item.MlrValidityDate;
        }
        if (item.MlrValidityEndDate < item.MlrValidityDate) {
          this.$fun.alert("La fecha fin no puede ser menor a la fecha inicio", "warning");
          return;
        }
      } else {
        item.MlrDescription = null;
        item.MlrValidityEndDate = null;
        item.MlrScope = 1;
      }
      item.MltID = this.parentID;
      item.save();
    },
    saveDetail(item) {
      if (this.isSpecialOnly) {
        this.$fun.alert("Su usuario solo cuenta con permisos para gestionar tarifas de Menú Especial.", "warning");
        return;
      }
      if (item.TypeContent == 0) {
        this.$fun.alert("Elija Tipo de Contenido", "warning");
        return;
      }
      item.MltID = this.parentID;
      console.log(item);
      item.save();
    },
  },
};
</script>

<style scoped>
.modern-alert {
  border-width: 1px !important;
  border-style: solid !important;
  border-left-width: 6px !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.07);
}
.alert-locked {
  border-color: #fca5a5 !important;
  border-left-color: #dc2626 !important;
  background-color: #fff1f2 !important;
}
.alert-pending {
  border-color: #93c5fd !important;
  border-left-color: #1d4ed8 !important;
  background-color: #eff6ff !important;
}
.alert-icon-box {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
}
.icon-locked {
  background-color: #dc2626 !important;
}
.icon-pending {
  background-color: #1d4ed8 !important;
}
.alert-title {
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.4px;
}
.alert-title-locked {
  color: #991b1b !important;
}
.alert-desc-locked {
  color: #450a0a !important;
  font-size: 0.77rem;
  font-weight: 500;
  line-height: 1.35;
}
.alert-title-pending {
  color: #1e3a8a !important;
}
.alert-desc-pending {
  color: #172554 !important;
  font-size: 0.77rem;
  font-weight: 500;
  line-height: 1.35;
}
</style>
